import Tooltip from '@components/Tooltip'
import { Trip } from '@types'
import React from 'react'
import { TestIds } from '@/testIds'
import {
    TripCardContainer,
    TripCardHeader,
    TripCode,
    TripCodeContainer,
    TripCodeLabel,
    TripTitle,
} from './TripCard.styles'

interface TripCardProps {
	trip: Trip
	onClick: (trip: Trip) => void
}

const TripCard: React.FC<TripCardProps> = ({ trip, onClick }) => {
	const handleClick = () => {
		onClick(trip)
	}

	return (
		<TripCardContainer onClick={handleClick} data-testid={TestIds.trips.card(trip.name)}>
			<TripCardHeader>
				<TripTitle>{trip.name}</TripTitle>
				<TripCodeContainer>
					<TripCodeLabel>Trip Code:</TripCodeLabel>
					<TripCode>{trip.code}</TripCode>
					<Tooltip text="Others can join this trip by entering this code on the website or in the iOS/Android app" />
				</TripCodeContainer>
			</TripCardHeader>
		</TripCardContainer>
	)
}

export default TripCard
